import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Checkpoints() {
  const [events, setEvents] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [checkpoints, setCheckpoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/touring-events/')
      .then((res) => {
        setEvents(res.data);
        if (res.data.length > 0) setSelectedId(res.data[0].id);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!selectedId) return;
    api.get(`/live-touring/${selectedId}/checkpoints`)
      .then((res) => setCheckpoints(res.data))
      .catch((err) => console.error(err));
  }, [selectedId]);

  const handleDelete = async (checkpointId) => {
    if (!window.confirm('Hapus checkpoint ini?')) return;
    try {
      await api.delete(`/live-touring/checkpoint/${checkpointId}`);
      setCheckpoints((prev) => prev.filter((c) => c.id !== checkpointId));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus checkpoint');
    }
  };

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;

  return (
    <Layout>
      <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Moderasi Checkpoint</h1>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 6, display: 'block' }}>Pilih Touring</label>
        <select
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%', maxWidth: 400 }}
        >
          {events.map((ev) => (
            <option key={ev.id} value={ev.id}>{ev.title} ({ev.status})</option>
          ))}
        </select>
      </div>

      {checkpoints.length === 0 ? (
        <p style={{ color: '#8B92A0' }}>Belum ada checkpoint di touring ini.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {checkpoints.map((c) => (
            <div key={c.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1 }}>
                  <p style={{ color: '#D02127', fontWeight: 700, fontSize: 13 }}>Checkpoint {c.urutan}</p>
                  {c.photos && c.photos.length > 0 && (
                    <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                      {c.photos.map((p, i) => (
                        <img key={i} src={p} alt="" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 6 }} />
                      ))}
                    </div>
                  )}
                  <p style={{ fontSize: 13, marginTop: 8 }}>{c.keterangan || '-'}</p>
                  <p style={{ color: '#8B92A0', fontSize: 11, marginTop: 6 }}>{c.posted_by_name} · {new Date(c.created_at).toLocaleString('id-ID')}</p>
                </div>
                <button
                  onClick={() => handleDelete(c.id)}
                  style={{ background: 'rgba(208,33,39,0.15)', color: '#D02127', border: 'none', padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}
                >
                  Hapus
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
